const imageSchema = {
  path: { type: 'file' },
  // Phase 4: 125-char cap mirrors the server. Required at publish time
  // (server validates against the parent filter's status).
  alt: { type: 'string', transform: ['trim'], maxLength: 125 },
  altAr: { type: 'string', transform: ['trim'], maxLength: 125 },
}

module.exports = imageSchema
